import { Bar, Doughnut, Line } from "react-chartjs-2";

import InfoLink from "@/containers/InfoLink";

import { BaseWidget } from "./BaseWidget";
import {
  barOptions,
  eventPropsForPie,
  eventPropsForTimeline,
  lineOptions,
  pieOptions,
} from "./chart_options";
import { CountText } from "./CountText";
import {
  getLabelsAndDatasetsForLineChart,
  getLabelsAndDatasetsForPieChart,
  sumArray,
} from "./helpers";

const hasData = (data) =>
  data &&
  data.map((d) => (d.popularityScore || []).length).reduce(sumArray, 0) > 0;

// ------------------------------------------------------------------------------------

const PopularityInfoLink = () => (
  <InfoLink
    content={L.MENTIONS_POPULARITY_HOW_CALCULATED}
    href={L.HELP_ARTICLE_POPULARITY}
  />
);

const PopularityScoreLineWidget = (props) => {
  const isStacked = props.chartType == "area_stacked";
  const chartData = getLabelsAndDatasetsForLineChart(
    "popularityScore",
    hasData(props.data) ? props.data : null,
    isStacked
  );
  const options = lineOptions(isStacked, props.size);

  return (
    <BaseWidget
      {...props}
      hasData={hasData(props.data)}
      extraHeader={<PopularityInfoLink />}
    >
      <Line
        data={chartData}
        options={{ ...options, ...eventPropsForTimeline(chartData, props) }}
      />
    </BaseWidget>
  );
};

const PopularityScoreBarWidget = (props) => {
  const isStacked = false;
  const chartData = getLabelsAndDatasetsForLineChart(
    "popularityScore",
    hasData(props.data) ? props.data : null,
    isStacked
  );

  return (
    <BaseWidget
      extraHeader={<PopularityInfoLink />}
      {...props}
      hasData={hasData(props.data)}
    >
      <Bar
        data={chartData}
        options={{
          ...barOptions(true, props.size),
          ...eventPropsForTimeline(chartData, props),
        }}
      />
    </BaseWidget>
  );
};

const PopularityScorePieWidget = (props) => {
  const chartData = getLabelsAndDatasetsForPieChart(
    "popularityScore",
    hasData(props.data) ? props.data : null,
    true
  );
  const options = pieOptions();

  return (
    <BaseWidget
      {...props}
      hasData={hasData(props.data)}
      extraHeader={<PopularityInfoLink />}
    >
      <Doughnut
        data={chartData}
        options={{ ...options, ...eventPropsForPie(chartData, props) }}
      />
    </BaseWidget>
  );
};

const PopularityScoreSumWidget = (props) => {
  const chartData = getLabelsAndDatasetsForPieChart(
    "popularityScore",
    hasData(props.data) ? props.data : null
  );

  const sum = chartData.datasets
    .map((i) => i.data.reduce(sumArray, 0))
    .reduce(sumArray, 0);

  return (
    <BaseWidget
      {...props}
      extraHeader={<PopularityInfoLink />}
      hasData={hasData(props.data)}
    >
      <CountText count={sum} {...props} />
    </BaseWidget>
  );
};

const PopularityScoreWidget = (props) => {
  return props.chartType == "pie" ? (
    <PopularityScorePieWidget {...props} />
  ) : props.chartType == "bar" ? (
    <PopularityScoreBarWidget {...props} />
  ) : props.chartType == "sum" ? (
    <PopularityScoreSumWidget {...props} />
  ) : (
    <PopularityScoreLineWidget {...props} />
  );
};

export { PopularityScoreWidget };
